import React from 'react';
import { HTMLInputProps, INumericInputProps, NumericInput } from '@blueprintjs/core';
import { TranslatedMessage } from '../../translation';
import { Overwrite } from '../../../../typings/typings';
import { TLCode } from '../../../../common/enums';

// tslint:disable-next-line:no-empty-interface
interface CommonNumberInputProps extends INumericInputProps {}

export type NumberInputProps = Overwrite<CommonNumberInputProps, { placeholder?: TLCode | string }> &
  Overwrite<HTMLInputProps, { placeholder?: TLCode | string }>;

const renderNumberInput = (props: CommonNumberInputProps & HTMLInputProps) => <NumericInput {...props} />;

const NumberInput = ({ placeholder, ...otherProps }: NumberInputProps) =>
  placeholder && placeholder in TLCode ? (
    <TranslatedMessage id={placeholder as TLCode}>
      {(tanslatedPlaceholder) => renderNumberInput({ ...otherProps, placeholder: tanslatedPlaceholder })}
    </TranslatedMessage>
  ) : (
    renderNumberInput({ ...otherProps, placeholder: placeholder as string })
  );

export default NumberInput;
